import * as React from 'react';
import { Close } from "@mui/icons-material";
import {
    Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Select, TextField
} from "@mui/material";
import { Dispatch, SetStateAction, useState, useEffect } from "react";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import EventBus from "../../EventBus";
import { CookService } from "../../services/CookServices";
import { CustomSnackbarTypes } from "./CustomSnackBar";
import {MgCookResponse} from "../../interfaces/Cook/MgCookResponse";

interface InputProps {
    setOpen: Dispatch<SetStateAction<boolean>>;
    open: boolean;
    isCreate: boolean;
    cookId: number;
    callBack: () => void
    data?: MgCookResponse | null;
}
const cookService = new CookService();
export const CreateMgCookDialog = (props: InputProps) => {
    const [salary, setSalary] = useState<string>('0');
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const [dailyMgPayout, setDailyMgPayout] = useState<string>('0');
    const [dailyMgConveyance, setDailyMgConveyance] = useState<string>('0');
    const [salaryVersion, setSalaryVersion] = useState<string>('V1');
    const [isConveyanceIncluded,setIsConveyanceIncluded]=useState<boolean>(false);

    const checkAndProcessData = async () => {
        let payload: {cookId?: number, salary: string, startDate: string, endDate?: string,isConveyanceIncluded:boolean, dailyMgPayout: string, salaryVersion: string, dailyMgConveyance: string} = {
            startDate,
            salary,
            isConveyanceIncluded,
            dailyMgPayout,
            salaryVersion,
            dailyMgConveyance
        }
        // foe edit scenario cookId should not be there
        if(!props?.data){
            payload = {
                ...payload,
                cookId: props.cookId,
            }
        }
        // for create scenario endDate should not be there
        if(!props.isCreate){
           payload = {
               ...payload,
               endDate: endDate,
           }
        }
        // the data will exist only when we edit it
        if(props?.data){
            // for edit scenario
            return await cookService.editMgCook(props.data.id ,payload)
        } else {
            // for create scenario
            return await cookService.createMgCook(payload)
        }
    };

    const handleSubmit = () => {
        if(salaryVersion === "V1" && Number(salary) <= 0){
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Salary must be provided",
                type: CustomSnackbarTypes.ERROR
            });
            return;
        }
        if(salaryVersion === "V2" && Number(dailyMgPayout) <= 0){
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "MG Payout must be provided",
                type: CustomSnackbarTypes.ERROR
            });
            return;
        }
        // if(salaryVersion === "V2" && Number(dailyMgConveyance) <= 0){
        //     EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        //         message: "MG Conveyance must be provided",
        //         type: CustomSnackbarTypes.ERROR
        //     });
        //     return;
        // }
        if(!props.isCreate && endDate === ''){
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "End date must be provided",
                type: CustomSnackbarTypes.ERROR
            });
            return;
        }
        if(startDate === ''){
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Start date must be provided",
                type: CustomSnackbarTypes.ERROR
            });
            return;
        }
        checkAndProcessData()
            .then(() => {
                setSalary('0');
                setStartDate('');
                setEndDate('');
                setIsConveyanceIncluded(false);
                props.callBack();
                handleClose();
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                    message: props.isCreate ? 'Created Successfully' : 'Updated Successfully',
                    type: CustomSnackbarTypes.SUCCESS
                });
            })
    };
    const handleClose = () => {
        props.setOpen(false);
    }

    useEffect(()=>{
        if(!props?.data) return;
        setSalary(String(props.data?.salary));
        // @ts-ignore
        setStartDate(props.data?.startDate);
        // @ts-ignore
        setEndDate(props.data?.endDate);
        // @ts-ignore
        setDailyMgPayout(props?.data?.dailyMgPayout)
        // @ts-ignore
        setDailyMgConveyance(props?.data?.dailyMgConveyance)
        // @ts-ignore
        setSalaryVersion(props.data.salaryVersion ?? 'V2');
    },[props?.data])
    return (
        <Dialog onClose={handleClose} open={props.open} scroll={"paper"} maxWidth="xl">
            <DialogTitle>{props.isCreate ? 'Create Mg Cook Salary' : 'Update Mg Cook Salary'}</DialogTitle>
            <DialogContent>
              <IconButton onClick={handleClose} sx={{ position: 'absolute', top: 10, right: 10 }}> <Close /> </IconButton>
              <Grid container columns={1} spacing={1} sx={{ padding: "10px", width: 300 }}>

                <Grid sm={12} md={12} xs={12} item>
                    <FormControl fullWidth>
                        <InputLabel id="salary-version-label">Salary Version</InputLabel>
                        <Select
                        labelId="salary-version-label"
                        id="salaryVersion"
                        value={salaryVersion}
                        label="Salary Version"
                        onChange={(e) => setSalaryVersion(e.target.value as 'V1' | 'V2')}
                        >
                        <MenuItem value="V1">V1</MenuItem>
                        <MenuItem value="V2">V2</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                {salaryVersion === 'V2' && (
                    <Grid sm={12} md={12} xs={12} item>
                    <TextField
                        id='dailyMgPayout'
                        label= "Daily MG Payout"
                        type='text'
                        fullWidth
                        variant='outlined'
                        value={dailyMgPayout}
                        onChange={(e: any) => {setDailyMgPayout(e.target.value)}}
                    />
                </Grid>
                )}

                {salaryVersion === 'V2' && (
                    <Grid sm={12} md={12} xs={12} item>
                    <TextField
                        id='dailyMgConveyance'
                        label= "Daily MG Conveyance"
                        type='text'
                        fullWidth
                        variant='outlined'
                        value={dailyMgConveyance}
                        onChange={(e: any) => {setDailyMgConveyance(e.target.value)}}
                    />
                </Grid>
                )}

                {salaryVersion === 'V1' && (
                    <Grid sm={12} md={12} xs={12} item>
                    <TextField
                        id="salary"
                        label={props.isCreate ? 'Salary' : 'New Salary'}
                        type="number"
                        fullWidth
                        variant={'outlined'}
                        value={salary}
                        onChange={(e: any)=>{setSalary(e.target.value)}}
                        // sx={{ width: 220 }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                 </Grid>
                )}
                {!props.isCreate &&
                <Grid sm={12} md={12} xs={12} item>
                    <TextField
                    id="end-date"
                    label="Previous salary End Date"
                    type="date"
                    fullWidth
                    variant={'outlined'}
                    value={endDate}
                    onChange={(e: any)=>{setEndDate(e.target.value)}}
                    // sx={{ width: 220 }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    />
                </Grid>
                }
                <Grid sm={12} md={12} xs={12} item>
                    <TextField
                        id="start-date"
                        label={props.isCreate ? 'Salary Start Date' : 'New Salary Start Date'}
                        type="date"
                        fullWidth
                        variant={'outlined'}
                        value={startDate}
                        onChange={(e: any)=>{setStartDate(e.target.value)}}
                        // sx={{ width: 220 }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <FormControlLabel control={<Checkbox checked={isConveyanceIncluded} onChange={()=>setIsConveyanceIncluded(!isConveyanceIncluded)} />} label="Is Conveyance Included" />
              </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    size={"large"}>
                    Submit
                </Button>
                <Button
                    variant="contained"
                    color={"error"}
                    onClick={handleClose}
                    size={"large"} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
